import React, { useState, cloneElement } from 'react';
import Tabs from '../components/hooks/Tabs';

function InvoicingSettingsLayout({ children, user }) {

    const [tabs, setTabs] = useState([
        { id: 1, name: 'Datos de facturación', current: false, route: '/facturacion/ajustes/informacion' },
        { id: 2, name: 'Mis certificados', current: false, route: '/facturacion/ajustes/certificados' }
    ]);

    return (
        <>
            <div className='w-full px-0 py-4 lg:p-6 bg-gray-100 min-h-[calc(100dvh-4rem)] pb-12'>
                <Tabs
                    items={tabs}
                    setItems={setTabs}
                />
                <div className='w-full px-4 lg:px-0'>
                    {cloneElement(children, { user })}
                </div>
            </div>
        </>
    )
}

export default InvoicingSettingsLayout